import search from 'assets/search.svg';
import { useEffect, useState } from 'react';

const SearchInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) => {
  const [value, setValue] = useState(initialValue);
  const [searchFocus, setSearchFocus] = useState(false);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className="border flex items-center rounded w-full text-sm font-normal">
      <input
        {...props}
        value={value}
        autoFocus={searchFocus ? true : false}
        onChange={(e) => setValue(e.target.value)}
        onFocus={() => {
          setSearchFocus(true);
        }}
        onBlur={() => {
          setSearchFocus(false);
        }}
      />
      {!searchFocus && <img src={search} className="w-5 h-5 mr-2 cyfi-svg dark:svg-dark-mode" alt="search" />}
    </div>
  );
};
export default SearchInput;
